import * as React from 'react';

import * as style from './SearchResultList.css';

export interface ISearchResultListProps {
  loader: React.ReactNode;
  plug: React.ReactNode;
}

export const SearchResultList: React.FC<React.PropsWithChildren<ISearchResultListProps>> = props => {
  const { children, loader, plug } = props;

  return (
    <div className={style['container']}>
      {plug && <div className={style['plug']}>{plug}</div>}
      {!plug && (
        <table className={style['content']}>
          <tbody>{children}</tbody>
        </table>
      )}
      {loader && <div className={style['loader']}>{loader}</div>}
    </div>
  );
};
